export const ROUTES_IDS = {
  ROOT: "root",
} as const
